export default __webpack_public_path__ + "static/media/1912.1426561a.png";